import { CouponNumber } from '@/components/CouponNumber';
import { CouponNumberGroupConfig } from '@/config/game';
import classnames from '@/utilities/classnames';
import createArrayFromNumber from '@/utilities/createArrayFromNumber';
import React from 'react';

export interface CouponNumberGroupProps extends CouponNumberGroupConfig {
  index: number;
  isFilled: boolean;
  couponIndex: string;
  crossedNumbers: number[];
  ariaHidden?: boolean;
  onClickCouponNumber: (index: number, value: number) => void;
}

export class CouponNumberGroup extends React.Component<CouponNumberGroupProps> {
  static defaultProps: Partial<CouponNumberGroupProps> = {
    hideCouponIndex: false,
    isFilled: false,
    title: '',
  };

  handleOnClickCouponNumber = (value: number): void => {
    this.props.onClickCouponNumber(this.props.index, value);
  };

  numberIsCrossed = (value: number): boolean => {
    return this.props.crossedNumbers.indexOf(value) >= 0;
  };

  numberIsDisabled = (value: number): boolean => {
    const { crossedNumbers, maxCrossed } = this.props;
    return !this.numberIsCrossed(value) && crossedNumbers.length >= maxCrossed;
  };

  render(): JSX.Element {
    const { title, amountNumbers, columns } = this.props;
    const style: React.CSSProperties = {
      flexGrow: columns,
    };
    const className: string = classnames('CouponNumberGroup', {
      'CouponNumberGroup--not-filled': !this.props.isFilled,
    });

    return (
      <div className={className} style={style}>
        {title && (
          <div className="CouponNumberGroup__title">
            <span>{title}</span>
          </div>
        )}

        <div
          className="CouponNumberGroup__numbers"
          aria-hidden={this.props.ariaHidden}
        >
          {createArrayFromNumber(amountNumbers).map((value: number) => {
            return (
              <CouponNumber
                key={value}
                value={value}
                index={this.props.index + '-' + this.props.couponIndex}
                width={100 / columns + '%'}
                isDisabled={this.numberIsDisabled(value)}
                ariaHidden={this.props.ariaHidden}
                isCrossed={this.numberIsCrossed(value)}
                onClick={this.handleOnClickCouponNumber}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
